import React from 'react';
const Txb = ({ children }) => ( 
    <div className='TextBlock'>
        {children}
    </div>);

export default React.memo(Txb)